import React from "react";
import Users from "./Users";

const CompanyUsers = () => <Users directory="company" />;

export default CompanyUsers;
